import {
  createFileRoute,
  type SearchSchemaInput,
} from '@tanstack/react-router';
import { useEffect } from 'react';

import { AgentToolsPage } from '@/features/agent-tools/AgentToolsPage';
import {
  defaultAgentToolsTab,
  isAgentToolsTabId,
  type AgentToolsTabId,
} from '@/features/agent-tools/agentToolsTabs';

export const Route = createFileRoute('/_baseLayout/agent-tools/')({
  component: AgentToolsRoute,
  validateSearch: (
    search: { tab?: string; chatId?: string } & SearchSchemaInput,
  ) => ({
    tab: isAgentToolsTabId(search?.tab) ? search.tab : defaultAgentToolsTab,
    chatId: search?.chatId as string | undefined,
  }),
});

function AgentToolsRoute() {
  const { tab, chatId } = Route.useSearch();
  const navigate = Route.useNavigate();

  // When the OAuth popup is redirected back here, relay the outcome to the
  // opener (the main Agent Tools window) so it can surface success/error, then
  // close.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauth = params.get('oauth');

    if (oauth && window.opener) {
      window.opener.postMessage(
        {
          type: 'mcp-oauth',
          oauth,
          message: params.get('message') ?? undefined,
        },
        window.location.origin,
      );
      window.close();
    }
  }, []);

  return (
    <AgentToolsPage
      tab={tab}
      onTabChange={(nextTab: AgentToolsTabId) =>
        navigate({ to: '/agent-tools', search: { tab: nextTab, chatId } })
      }
    />
  );
}
